/* NYM conversion analytics — single helper, GA4-compatible dataLayer.
   Never pass PII (name, email, phone, address) into track(). */
(function () {
  window.NYMAnalytics = window.NYMAnalytics || {
    track: function (eventName, params) {
      if (!eventName) return;
      window.dataLayer = window.dataLayer || [];
      var payload = { event: eventName };
      if (params) {
        for (var k in params) {
          if (Object.prototype.hasOwnProperty.call(params, k) && params[k] !== undefined) payload[k] = params[k];
        }
      }
      window.dataLayer.push(payload);
    }
  };

  /* Declarative local-conversion tracking:
     <a data-nym-track="get_directions_click" data-nym-track-store="hylan"> */
  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-nym-track]');
    if (!el) return;
    window.NYMAnalytics.track(el.getAttribute('data-nym-track'), {
      store: el.getAttribute('data-nym-track-store') || undefined
    });
  });

  if (document.body && document.body.hasAttribute('data-nym-location-page')) {
    window.NYMAnalytics.track('location_page_view', { store: document.body.getAttribute('data-nym-location-page') });
  }
})();
